
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 27 34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.002.001a.77.77 0 00-.566.278L5.302 6.486.18 12.693a.772.772 0 000 .99l5.122 6.207 5.134 6.194a.772.772 0 001.362-.483v-6.63c2.76-.688 4.88-.8 6.4-.47 1.624.353 2.58 1.127 3.181 2.33 1.204 2.407.707 6.828-1.12 12.149a.773.773 0 001.337.724c5.23-6.839 6.534-13.743 4.472-18.922-1.934-4.855-6.847-8.022-13.692-8.055-.192 0-.382.007-.578.012V.773A.77.77 0 0011.002 0v.001z","fill":"#fff"}})])
          )
        }
      }
    